<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('toles_applications')"
                        :isNewButton="checkPermission('internshipapplication_store')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('toles_applications')"
                              :isNewButton="checkPermission('internshipapplication_store')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('tolesapplication_excelexport')"
                              @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('university_name')">
                            <university-selectbox v-model="datatable.queryParams.filter.university_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('application_type')">
                            <ParameterSelectbox v-model="datatable.queryParams.filter.application_type"  code="toles_application_types"  :public="true"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('course_code_option')+ '/'+$t('exam_name')">
                        <ParameterSelectbox v-model="datatable.queryParams.filter.application_detail"  code="toles_application_details"  :public="true"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('payment_status')">
                            <YesNoSelectbox v-model="datatable.queryParams.filter.payment_status"  />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.payment_date_greater_than"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="datatable.queryParams.filter.payment_date_smaller_than"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('tolesapplication_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :form="row"
                               v-if="formProcess==='show'"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
//Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

//Component
import DatatableFilter from '@/components/datatable/DatatableFilter';
import Datatable from '@/components/datatable/Datatable';
import CommonModal from '@/components/elements/CommonModal';

//Page
import ShowForm from './Show.vue'

//Service
import InternshipApplicationService from '@/services/InternshipApplicationService';

//Other
import qs from 'qs';
import TolesApplicationServices from "@/services/TolesApplicationServices";

export default {
    components: {
        AppLayout,
         ShowForm,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
    },
    metaInfo() {
        return {
            title: this.$t('toles_applications')
        }
    },
    data() {
        return {
            formId: 0,
            form: {},
            formProcess: null,
            row:{},
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        hidden: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('detail'),
                                class: 'ri-search-eye-line',
                                permission: "tolesapplication_show",
                                callback: (row) => {
                                    this.showForm(row)
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "tolesapplication_delete",
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('university_name'),
                        field: this.getLocaleField('university_name'),
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('faculty'),
                        field: this.getLocaleField('faculty'),
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('program'),
                        field: this.getLocaleField('program'),
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('application_type'),
                        field: 'application_type_name',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('course_code_option') + ' ' + this.toUpperCase(this.$t('exam_name')),
                        field: 'application_detail',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('student_status'),
                        field: 'student_status',
                        hidden: false,
                        formatFn:(row)=>{
                            if (row === '101') {
                                return this.$t('continue')
                            }
                            else if (row === '102') {
                                return this.$t('graduated')
                            }else {
                                return  ' '
                            }
                        }
                    },
                    {
                        label: this.toUpperCase('payment_status'),
                        field: 'payment_status',
                        hidden: false,
                        formatFn:(row)=>{
                                if (row ==='E') {
                                    return '<span class="badge badge-success mb-0">' + this.$t('yes') + '</span>'
                                }
                                else {
                                    return '<span class="badge badge-danger mb-0">' + this.$t('no') + '</span>'
                                }
                        }
                    },
                    {
                        label: this.toUpperCase('payment_date'),
                        field: 'payment_date',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('amount'),
                        field: 'amount',
                        hidden: false,
                        formatFn:(val,row)=>{
                            return this.currencyFormat(val,row?.currency??'TRY')
                        }
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'created_at',
                    page: 1,
                    limit: 20
                }
            }
        };
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return TolesApplicationServices.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        showForm(row) {
            this.row = row
            this.formProcess = 'show'
            this.$refs.showModal.$refs.commonModal.show()
        },
        downloadExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            TolesApplicationServices.excelExport(config)
                .then(res => this._downloadFile(res, this.$t('toles_applications') + '.xlsx'))
                .catch(err => this.showErrors(err))
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        TolesApplicationServices.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
    }
}
</script>
